import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import useSWR from 'swr';
import { getFetcher } from '@/api/fetchers';
import { PersonLayout } from '../PersonLayout';
import { type ComboboxItem } from '@mantine/core';
import { type ClientDetailed } from '@/schemas/API/GET/client/response';

const navigationOptions: ComboboxItem[] = [
  {
    label: 'Osobní údaje',
    value: 'personal',
  },
  {
    label: 'Detaily',
    value: 'details',
  },
  {
    label: 'Individuální plán péče',
    value: 'ipp',
  },
  {
    label: 'Preference zaměstnanců',
    value: 'preferences',
  },
];

export const ClientLayout = (): JSX.Element => {
  const { clientId } = useParams<{ clientId: string }>();

  const { data: client } = useSWR<ClientDetailed>(
    `/clients/${clientId}`,
    getFetcher
  );

  const clinetServicesId: number[] | undefined = client?.carePlans.map(
    carePlan => carePlan.serviceId
  );

  const [fullname, setFullname] = useState<string | undefined>(undefined);

  // Set the person's fullname when we got a client.
  useEffect(() => {
    if (!client) return;
    setFullname(`${client.firstName} ${client.lastName}`);
  }, [client]);

  return (
    <PersonLayout
      fullname={fullname}
      onClosePath="/clients"
      serviceDependentSections={['details', 'ipp']}
      navigationOptions={navigationOptions}
      inputSection={undefined}
      checkForServicePresence
      presentServicesId={clinetServicesId}
    />
  );
};
